import React from 'react'
import { FaEdit } from 'react-icons/fa'
import { IChecklistItem } from '@oneethos/shared'

interface ChecklistItemsLoanApplicationListProps {
  checklistItems: IChecklistItem[]
  onStartEditing: (item: IChecklistItem) => void
  onStartAdding: () => void
  isAdding: boolean
}

const ChecklistItemsLoanApplicationList = ({
  checklistItems,
  onStartEditing,
  onStartAdding,
  isAdding
}: ChecklistItemsLoanApplicationListProps) => {
  const itemsSortedBySequence = checklistItems
    .sort((a, b) => (a.sequence) - (b.sequence))

  return (
    <>
      <div className="mb-3">
        <span className="text-dark fw-bold">Loan Application Items: {checklistItems.length}</span>
      </div>
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Name</th>
              <th>Type</th>
              <th>Data Field</th>
              <th>owner</th>
              <th>Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {itemsSortedBySequence.map((item) => (
              <tr key={item.id}>
                <td>{item.sequence}</td>
                <td>{item.label}</td>
                <td>{item.type}</td>
                <td>{item.dataField || 'N/A'}</td>
                <td>{item.owner}</td>
                <td>{item.active ? 'Yes' : 'No'}</td>
                <td className='pointer'>
                  <FaEdit onClick={() => onStartEditing(item)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {checklistItems.length === 0 && !isAdding && (
        <div className="text-center text-muted py-4">
          <p>No checklist items found.</p>
        </div>
      )}
      <button
        className="btn btn-primary"
        onClick={onStartAdding}
        disabled={isAdding}
      >
        Add Checklist Item
      </button>
    </>
  )
}

export default ChecklistItemsLoanApplicationList